import { MARK_LINK, render } from "storyblok-rich-text-react-renderer";

import type { BlokLink } from "@/storyblok";
import type { StoryblokRichtext } from "@/storyblok-base";
import { Link } from "@/i18n/Link";

import { Prose } from "../Prose";
import { StoryblokComponent } from "@frend-digital/storyblok";

interface SBRichText {
	blok: StoryblokRichtext | string | BlokLink;
	preview: boolean;
	className?: string;
	small?: boolean;
	openExternalLinksInNewWindow?: boolean;
}

export const RichTextRender = ({
	blok,
	preview,
	className = "",
	small,
	openExternalLinksInNewWindow = false,
}: SBRichText) => {
	return (
		<Prose small={small} className={className}>
			{render(blok, {
				defaultBlokResolver: (name, props) => (
					<StoryblokComponent preview={preview} blok={{ component: name, ...props }} />
				),
				markResolvers: {
					[MARK_LINK]: (children, attributes) => {
						if (!attributes.href) {
							return <>{children}</>;
						}

						const isExternal = attributes.linktype === "url";
						const linkProps =
							isExternal && openExternalLinksInNewWindow
								? { target: "_blank", rel: "noopener noreferrer" }
								: attributes.target
									? { target: attributes.target }
									: {};

						return (
							<Link href={attributes.href} {...linkProps}>
								{children}
							</Link>
						);
					},
				},
			})}
		</Prose>
	);
};
